import { useEffect, useState } from "react";
import { Building2, Home, Users } from "lucide-react";

import api from "../../lib/api";
import { Loading } from "../../components/shared";

export default function ResidentUnitDetail() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/resident/unit").then((response) => setData(response.data));
  }, []);

  if (!data) return <Loading />;
  const { unit, my_relationships: relationships, household } = data;

  return (
    <div data-testid="resident-unit-detail-page">
      <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">My Unit</p>
      <h1 className="mt-2 font-display text-4xl font-bold text-slate-900">Unit {unit.unit_number}</h1>
      <div className="mt-8 grid gap-4 lg:grid-cols-2">
        <section className="border border-slate-200 bg-white p-5" data-testid="resident-unit-overview">
          <Building2 className="h-5 w-5 text-primary" />
          <h2 className="mt-4 font-display text-lg font-semibold">Overview</h2>
          <dl className="mt-4 space-y-2 text-sm text-slate-700">
            <Info label="Building" value={unit.building || "Not recorded"} />
            <Info label="Wing" value={unit.wing || "Not recorded"} />
            <Info label="Floor" value={unit.floor || "Not recorded"} />
            <Info label="Type" value={unit.unit_type || "Not recorded"} />
            <Info label="Status" value={unit.occupancy_status || "Not recorded"} />
          </dl>
        </section>
        <section className="border border-slate-200 bg-white p-5" data-testid="resident-unit-relationship">
          <Home className="h-5 w-5 text-primary" />
          <h2 className="mt-4 font-display text-lg font-semibold">My relationship</h2>
          <div className="mt-4 space-y-2 text-sm text-slate-700">
            {relationships.summary.map((role) => <p key={role}>{role.replaceAll("_", " ")}</p>)}
            {relationships.ownership.map((row, index) => (
              <p key={`owner-${index}`}>{row.ownership_role.replaceAll("_", " ")} · since {row.start_date || "recorded"}</p>
            ))}
            {relationships.occupancy.map((row, index) => (
              <p key={`occupant-${index}`}>{row.occupancy_role.replaceAll("_", " ")} · since {row.start_date || "recorded"}</p>
            ))}
          </div>
        </section>
      </div>
      <section className="mt-4 border border-slate-200 bg-white p-5" data-testid="resident-unit-household-preview">
        <Users className="h-5 w-5 text-primary" />
        <h2 className="mt-4 font-display text-lg font-semibold">Household</h2>
        <p className="mt-2 text-sm text-slate-600">
          {household.length ? `${household.length} current household member${household.length > 1 ? "s" : ""} recorded.` : "No household members are recorded for this home."}
        </p>
      </section>
    </div>
  );
}

function Info({ label, value }) {
  return <div className="flex justify-between gap-4"><dt>{label}</dt><dd className="text-right font-medium">{value}</dd></div>;
}